import styled from 'styled-components'

export const NavBackground = styled.div<{ isDispensaryLogo: boolean }>`
  position: absolute;
  left: 0;
  top: 0; // move to top since body has a top padding
  width: 100%;
  background-color: ${({ theme, isDispensaryLogo }) =>
    isDispensaryLogo
      ? theme.colors.component.backgroundDarkBlue
      : `${theme.colors.component.backgroundDarkBlue}D8`};
  height: var(--nav-fixed-height);
  @media print {
    display: none;
  }
`

export const PrintLogoImage = styled.img`
  display: none;
  @media print {
    display: block;
    height: 50px;
    margin: 10px auto;
  }
`
